import { render, staticRenderFns } from "./LKPublicationsFormdataRevisionsList.vue?vue&type=template&id=31383fac&"
import script from "./LKPublicationsFormdataRevisionsList.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataRevisionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports